import { render, staticRenderFns } from "./editor-panel-versions.vue?vue&type=template&id=765bbc5e&scoped=true"
import script from "./editor-panel-versions.vue?vue&type=script&lang=js"
export * from "./editor-panel-versions.vue?vue&type=script&lang=js"
import style0 from "./editor-panel-versions.vue?vue&type=style&index=0&id=765bbc5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765bbc5e",
  null
  
)

export default component.exports